export default "__VITE_ASSET__CgZgef_n__"